import Layout from '@/pages/Layout';

export default [
    {
        path: '/office',
        redirect: 'noredirect',
        component: Layout,
        name: 'office',
        meta: {
            title: '行政中心',
            icon: 'el-icon-office-building'
        },
        children: [
            {
                path: 'officeDesignTitle',
                name: 'officeDesignTitle',
                id: 'officeDesignTitle',
                meta: {
                    title: '行政设计',
                    icon: 'el-icon-s-operation'
                },
                sortOrder: 70,
                isDesign: true,
                isTitle: true,
                isShow: false,
                isMenuWaterfall:false
            // isSubMenu: true
            },
            {
                path: 'attendance',
                component: () => import('@/pages/office/attendance/AttendanceList'),
                // redirect: 'noredirect',
                name: 'attendance',
                id: 'office/attendance',
                meta: {
                    title: '考勤打卡',
                    icon: 'iconfont icon-other-qiandao-kaoqindaqia bc-custom-menu',
                    color: '#f60d0d'
                },
                isMenuWaterfall:true
            },
            // {
            //     path: 'department-add/:pId/:pName',
            //     component: () => import('@/pages/office/department/DepartmentDetail'),
            //     isShow: false,
            //     name: 'departmentAdd',
            //     id: 'office/department-add/:pId/:pName',
            //     meta: {
            //         title: '添加部门',
            //         icon: 'beer'
            //     }
            // },
            {
                path: 'workTime',
                component: () => import('@/pages/office/workTime/WorkTimeList'),
                // redirect: 'noredirect',
                name: 'workTime',
                id: 'office/workTime',
                meta: {
                    title: '打卡地点',
                    icon: 'iconfont icon-other-didiandingwei bc-custom-menu',
                    color: '#f45e25'
                },
                isMenuWaterfall:true
            },
            {
                path: 'appeal',
                component: () => import('@/pages/office/appeal/AppealList'),
                // redirect: 'noredirect',
                name: 'appeal',
                id: 'office/appeal',
                meta: {
                    title: '打卡申诉',
                    icon: 'iconfont icon-other-shensushenpi bc-custom-menu',
                    color: '#e82e2e'
                },
                isMenuWaterfall:true
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-office.js